import React from 'react';

import { useExperienceModuleContext } from 'modules/experience-core';

import Nps from '../Nps';
import useIsNpsFlagEnabled from '../useIsNpsFlagEnabled';

type ExperienceNpsProps = {
  manual?: boolean;
  onClose?: () => void;
};

export const ExperienceNps = ({ manual = false, onClose }: ExperienceNpsProps) => {
  const { selectedExperienceVenueEntity } = useExperienceModuleContext();
  const isNpsFlagEnabled = useIsNpsFlagEnabled();
  if (!selectedExperienceVenueEntity) {
    return null;
  }
  const venue = selectedExperienceVenueEntity.experienceEntityObject;
  return isNpsFlagEnabled && venue ? <Nps venue={venue} manual={manual} onClose={onClose} /> : null;
};
